<template>
    <div class="ma-0 pa-0 d-flex align-center">
        <!-- //* input for adding the file -->
        <input type="file" ref="fileinput" style="display: none" @change="previewFile" :accept="allowedtypes"/>
        <!-- <input type="file" ref="fileinput" style="display: none" @change="previewFile" :accept="GET_docUpload.allowedTypes"/> -->
        <!-- //* upload button -->

        <v-progress-circular
        v-if="isUploading"
      :rotate="360"
      :size="40"
      :width="5"
      :value="uploadValue.toFixed(0)"
      color="primary"
      class="mr-5"
    >
    {{ uploadValue.toFixed(0) }}
    </v-progress-circular>
        <appbutton label="UPLOAD"  icon="icons8-upload-to-cloud"  type="darkgrey"  @click.native="fileClick"  :class="{ 'disabled': isUploading }"/> 
        <!-- //* upload progress row -->
        <v-row class="px-1 py-0 mb-0" v-if="hideUploadButton === false && isUploading">
            <v-progress-linear v-model="uploadValue" height="25">
                <strong>{{ Math.ceil(uploadValue) }}%</strong>
            </v-progress-linear>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        allowedtypes: {
            type: String,
            default: 'application/pdf',
        },
        folder: {
            type: String,
            default: ''
        },
        doclink: {
            type: Object,
            default: {
                collection: '',
                documentId: ''
            }
        }
    },
    // * DATA
    data: () => ({
        fileData: null,
        fileType: '',
        hideUploadButton: false,
    }),
    computed: {
        ...mapGetters({
            GET_docUpload: 'docUpload_store/GET_docUpload',
        })
    },
    // * WATCH
    watch: {
        fileData: async function() {
            var t = this;
            var uploadFileResult = await t.MIX_uploadFile(t.folder, t.fileData, t.doclink );
            t.MIX_docUploadResult(uploadFileResult.data);
        },
    },
    // * METHODS
    methods: {
        
        fileClick() {
            this.$refs.fileinput.click();
        },
        previewFile: async function(event) {
            this.fileURL = null;
            this.fileData = event.target.files[0]; // asign fileData for preview
        },
    }
}
</script>